module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "form-title pt-0 float-left"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('a', {
    staticClass: "form-title pt-0 float-right",
    attrs: {
      "href": _vm.pat_detail.pdfPath,
      "target": "_blank",
      "underline": false
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o mr-1",
    staticStyle: {
      "color": "#e79178"
    }
  }), _vm._v("查看\n    ")])]), _vm._v(" "), _c('table', {
    staticClass: "index_tableBox__ZadJW",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("申请号")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pat_detail['patentNum']) + "\n      ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("申请日")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pat_detail['applicationTime']) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("申请公布号")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pat_detail['applicationPublishNum']) + "\n      ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("申请公布日")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pat_detail['appubDate']) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("授权公告号")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pat_detail['grantNumber']) + "\n      ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("授权公告日")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pat_detail['grantDate']) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("分类号")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "85%",
      "colspan": "3"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pat_detail['allCatNum']) + "\n      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-title"
  }, [_vm._v("申请人信息")]), _vm._v(" "), _c('table', {
    staticClass: "index_tableBox__ZadJW",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("申请（专利权）人")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pat_detail['applicantName']) + "\n      ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("发明人")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pat_detail['inventor']) + "\n      ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("地址")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pat_detail['address']) + "\n      ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("邮编")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-title"
  }, [_vm._v("代理人信息")]), _vm._v(" "), _c('table', {
    staticClass: "index_tableBox__ZadJW",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("代理机构")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pat_detail['agency']) + "\n      ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("代理人")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pat_detail['agent']) + "\n      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-title"
  }, [_vm._v("摘要")]), _vm._v(" "), _c('table', {
    staticClass: "index_tableBox__ZadJW",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.pat_detail['abstracts'])
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-title"
  }, [_vm._v("法律状态")]), _vm._v(" "), _c('table', {
    staticClass: "index_tableBox__ZadJW",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_vm._m(0), _vm._v(" "), _vm._l((_vm.pat_detail.stateOfLaw), function(k, v) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(v + 1) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(k['date']) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(k['detail']) + "\n      ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(k['status']) + "\n      ")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-title"
  }, [_vm._v("权利要求")]), _vm._v(" "), _c('table', {
    staticClass: "index_tableBox__ZadJW",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#FFFFFF"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.pat_detail['claims'])
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-title"
  }, [_vm._v("说明书")]), _vm._v(" "), _c('table', {
    staticClass: "index_tableBox__ZadJW",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#FFFFFF"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.pat_detail['description'])
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("序号\n      ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("状态公告日\n      ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("状态\n      ")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("状态信息\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bca20aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PatentDetail.vue
// module id = 281
// module chunks = 1